export enum ProductSyncChangeType {
    Added = 1,
    Removed = 2,
    Changed = 3
}